import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';

@Component({
  selector: 'ngx-boton-añadir-registro',
  template: `
    <div class="d-flex justify-content-center">
      <button nbButton size="small" status="basic" (click)="onClick()" nbTooltip="Crear nuevo registro en parcela">
        <nb-icon icon="file-add-outline"></nb-icon>
      </button>
    </div>
  `
})
export class BotonAddRegistroComponent implements ViewCell {
  @Input() value: any;
  @Input() rowData: any;

  @Output() click: EventEmitter<any> = new EventEmitter();

  onClick() {
    this.click.emit(this.rowData);
  }
}
